module.exports = __webpack_public_path__ + "static/media/9.5b5240a0.mp3";